import { Modal } from "flowbite-react";
import { useCallback, useContext, useState } from "react";
import Tags from "@yaireo/tagify/dist/react.tagify"; // React-wrapper file
import "@yaireo/tagify/dist/tagify.css"; // Tagify CSS
import restService from "../../../../restService";
import CampaignContext from "../../../../contexts/CampaignContext";
import UserContext from "../../../../contexts/UserContext";
import { PulseLoader } from "react-spinners";

export default function InviteMember({
  show,
  onClose,
  setLoading,
  getMembers,
  loading,
}) {
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);
  const [emails, setEmails] = useState([]);

  const onChange = useCallback((e) => {
    const tempArr = [];
    const temp = e.detail.tagify.getCleanValue();
    for (let i = 0; i < temp.length; i++) {
      tempArr.push(temp[i].value);
    }

    setEmails(tempArr);
  }, []);

  const tagifySettings = {
    maxTags: 6,
    transformTag: transformTag,
    addTagOnBlur: false,
    placeholder: "Type email address and press enter",
    dropdown: {
      enabled: 0,
    },
  };

  function transformTag(tagData) {
    tagData.style = "--tag-bg: rgba(78, 164, 255, 0.21)";
  }

  const settings = {
    ...tagifySettings,
    whitelist: [],
  };

  const handleInvite = async () => {
    setLoading(true);
    try {
      const {
        data: { message },
      } = await restService.Settings.inviteMembers(
        campaign.id,
        emails,
        user.accessToken
      );

      getMembers?.();
      setEmails([]);
      //   onClose();
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Modal show={show} onClose={onClose}>
      <>
        {/* Invite member */}
        {!loading ? (
          <div className="md:p-12 p-5">
            <h4 className=" text-[20px] text-[#24211D]">Invite members</h4>

            <div className="mt-6 flex flex-col gap-2">
              <label htmlFor="tags" className=" text-sm">
                Invitee Email Address
              </label>
              <Tags
                mode="textarea"
                value={emails}
                settings={settings}
                showDropdown={false}
                onChange={onChange}
              />
            </div>

            <div className=" flex md:flex-row  items-center gap-1 md:gap-3 mt-12">
              <button
                disabled={emails.length < 1 || loading}
                onClick={handleInvite}
                className="bg-[#3989DD] disabled:bg-[#dcdbdb] md:text-sm text-xs transition-all hover:bg-[#3277c0] py-2 px-5 text-white rounded"
              >
                Invite Member(s)
              </button>
              <button
                className=" border rounded py-2 md:text-sm text-xs px-7 hover:bg-[#c700001a] hover:text-red-600"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div className="md:p-12 p-5 flex justify-center flex-col items-center">
            <h4 className=" text-[24px] font-[700] text-[#24211D]">
              Please wait...
            </h4>
            <p className=" text-[14px] text-[#b4b4b4]">Inviting member(s).</p>

            <div className=" flex md:flex-row  items-center gap-1 md:gap-3 mt-1">
              <PulseLoader color="#FF6A3A" />
            </div>
          </div>
        )}
      </>
    </Modal>
  );
}
